import * as storage from '../persistance/storage';
import * as authConstants from '../constants/auth';


export default function isLoggedIn() {

	let token = storage.get('token');
	let expiry = null;
	try {
		expiry = parseInt(storage.get('tokenExpiry'));
	} catch(error) {
		return false;
	}

	if(!token || token.length < 24) {
		return false;
	}
	if(!expiry || expiry < Date.now()) {
		return false;
	}
	// saveLogin(token);
	return true;
}

export function getNeedsPasswordReset() {
	return false;
}

export function saveLogin(token, admin = false, role = false, remote = false, uid = null, user = null) {
	storage.put('token', token);
	storage.put('tokenExpiry', Date.now() + authConstants.LOGOUT_TIME);
	if(admin) {
		storage.put('ad', admin);
	}
	if(role) {
		storage.put('rl', role);
	}
	if(remote) {
		storage.put('remote', 'remote');
	}
	if(uid) {
		storage.put('uid', uid);
	}

	if(user) {
		storage.put('usr', JSON.stringify(user));
	}
}

export function getMyId() {
	return storage.get('uid');
}

export function getUserObj() {
	return JSON.parse(storage.get('usr'));
}

export function isIos() {

	const isIphone = navigator.userAgent.indexOf("iPhone") !== -1;
	const isIpod = navigator.userAgent.indexOf("iPod") !== -1;
	const isIpad = navigator.userAgent.indexOf("iPad") !== -1;

	return isIphone || isIpod || isIpad ; 
}

export function isMobileDevice() {
	return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export function isAdmin() {

	// isAdmin and isSY are the same; currently not using is_admin level in-app; all permissions based on role
	// if(isLoggedIn() === true) {
	// 	return storage.get('ad');
	// } else {
	// 	return false;
	// }

	if(isLoggedIn() === true) {

		return storage.get('rl') === 'SY';
	} else {
		return false;
	}
}

export function isSA() {

	if(isLoggedIn() === true) {
		return storage.get('rl') === 'SA';
	} else {
		return false;
	}
}

export function isGM() {

	if(isLoggedIn() === true) {
		return storage.get('rl') === 'GM';
	} else {
		return false;
	}
}

export function isVP() {

	if(isLoggedIn() === true) {
		return storage.get('rl') === 'VP';
	} else {
		return false;
	}
}

export function isSY() {

	if(isLoggedIn() === true) {

		return storage.get('rl') === 'SY';
	} else {
		return false;
	}
}

export function isRemoteUser() {
	if(isLoggedIn() === true) {
		return storage.get('remote') !== null;
	} else {
		return false;
	}
}

export function isWatchUser() {
	if(isLoggedIn() === true) {
		const usr = getUserObj();
		return usr.watch_user && usr.watch_user === true;
	} else {
		return false;
	}
}

export function isFinanceUser() {
	if(isLoggedIn() === true) {
		const usr = getUserObj();		
		return usr.finance_user && usr.finance_user === true;
	} else {
		return false;
	}
}

export function isDdnyUser(config = {}) {
	if(isLoggedIn() === true) {
		
		const isAdmin = config?.admin;
		const isNyLimited = config?.nyLimited;

		const usr = getUserObj();
		
		if(isAdmin) {
			return usr['ddny_user_admin'] === true;
		} else if(isNyLimited) {
			if(usr['ddny_user_admin'] === true) {
				return true;
			}
			const isNyLocation = usr?.locations.some(location => location.asc_id === 51);
			return !!(usr['ddny_user_read'] === true && isNyLocation);
		} else {
			return (usr['ddny_user_admin'] === true || usr['ddny_user_read'] === true);
		}
		
	} else {
		return false;
	}
}

export function logout() {
	storage.clear();
}